export const desktopAppDataHooks = {
  infoPopUp: 'info-pop-up',
  wixStudioNewToolbar: 'wix-studio-new-toolbar',
  wixStudioTemplateDemo: 'wix-studio-template-demo',
};
